import {
  FEEDBACK_26_CO_STEPS,
  type Feedback26CoStep,
  useFeedback26CoStore,
} from '@/stores/feedback-26-co';

interface ProgressBarProps {
  currentStep: Feedback26CoStep;
}

const STEP_LABELS: Record<Feedback26CoStep, string> = {
  overall: 'Experiencia General',
  quality: 'Calidad del Evento',
  improvement: 'Mejora Continua',
  sponsors: 'Sponsors',
  future: 'Futuro',
  extras: 'Extras',
  aura: 'AURA',
  'thank-you': 'Gracias',
};

export function ProgressBar({ currentStep }: ProgressBarProps) {
  const { maxStepReached } = useFeedback26CoStore();

  const maxIndex = FEEDBACK_26_CO_STEPS.indexOf(maxStepReached);
  const progress =
    maxIndex >= 0 ? (maxIndex + 1) / FEEDBACK_26_CO_STEPS.length : 0;

  return (
    <div className="space-y-3">
      <div className="h-1 w-full overflow-hidden rounded-full bg-card">
        <div
          className="h-full bg-primary transition-all duration-300"
          style={{ width: `${progress * 100}%` }}
        />
      </div>

      <div className="font-semibold text-lg">
        {STEP_LABELS[currentStep] || currentStep}
      </div>
    </div>
  );
}
